import { NgModule } from '@angular/core';

import { FitHeightDirective } from './fit-height.directive';

@NgModule({
    imports: [],
    exports: [ FitHeightDirective ],
    declarations: [FitHeightDirective],
    providers: [],
})
export class FitHeightModule { }
